import { Injectable } from '../../../../node_modules/@angular/core';
import { CanActivate, RouterStateSnapshot, Router, ActivatedRouteSnapshot } from '../../../../node_modules/@angular/router';
import { AuthService } from './auth.services';

@Injectable()
export class UserAuth implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.getAdminDetails()) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

  canLoad() {
    if (this.authService.getAdminDetails()) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

}
